import { css } from '@emotion/react';

export const values = css`
  display: flex;
  align-items: center;
  margin-top: calc(var(--unit) * 4);
  flex-wrap: wrap;
`;
